export default {
  title: 'Porquê regenerar esta imagem?',
  description: 'Ajude-nos a melhorar a IA dizendo-nos o que estava errado.',
  reasons: {
    wrong_style: 'Estilo incorreto',
    wrong_colors: 'Cores incorretas',
    wrong_food_item: 'Alimento incorreto',
    low_quality: 'Baixa qualidade',
    doesnt_match_brand: 'Não corresponde à minha marca',
    text_issues: 'Texto ou etiquetas incorretos',
    other: 'Outro',
  },
  details_label: 'Mais alguma coisa? (opcional)',
  details_placeholder: 'Adicione mais detalhes para nos ajudar a compreender…',
  cancel: 'Cancelar',
  confirm: 'Regenerar',
};
